/*
 * @Descripttion:
 * @version:
 * @Author: sueRimn
 * @Date: 2020-05-24 14:04:52
 * @LastEditors: dandan.Wu
 * @LastEditTime: 2021-03-30 10:13:29
 */

import fetch from '@/utils/fetch'
import {
  getClassIfy,
  getTag,
  getActListUrl,
  getActTypeListUrl,
  getPlanList,
  getTypeAreaList,
  getTagListUrl,
  getTagsByNameUrl,
  saveVideos,
} from './urls'
import { AxiosResponse } from 'axios'

/**
 * @name: GetClassIfy 分类
 * @param {type} 可不传参
 * @return: Promise
 */
export function GetClassIfy(data = {}): Promise<AxiosResponse> {
  return fetch.get(getClassIfy, { params: data })
}

/**
 * @name: getTag 标签
 * @param {type} 可不传参
 * @return: Promise
 */
export function GetTag(tag: string): Promise<AxiosResponse> {
  return fetch.get(`${getTag}/${tag}`, { params: {} })
}

/**
 * @name: getActList 活动列表
 * @param {type} 可不传参
 * @return: Promise
 */
export function GetActList(data = {}): Promise<AxiosResponse> {
  return fetch.get(getActListUrl, { params: data })
}

/**
 * @name: getActTypeList 活动类型
 * @param {type} 可不传参
 * @return: Promise
 */
export function GetActTypeList(data = {}): Promise<AxiosResponse> {
  return fetch.get(getActTypeListUrl, { params: data })
}

/**
 * @name: GetPlanList 计划列表
 * @param {type}
 * @return: Promise
 */
export function GetPlanList(data = {}): Promise<AxiosResponse> {
  return fetch.get(getPlanList, { params: data })
}

export function PostVideos(
  data: UploadVideoAPI.SaveVideoTypeNew
): Promise<AxiosResponse> {
  return fetch.post(saveVideos, data)
}

/**
 * @name: getClassify 获取分类 分区
 * @return: Promise
 */
export function getTypeAreaListReq(data = {}): Promise<AxiosResponse> {
  return fetch.get(getTypeAreaList, { params: data })
}

/**
 * @name: getClassify 获取标签
 * @param {type}
 * @return: Promise
 */
export function getTagListReq(data = {}): Promise<AxiosResponse> {
  return fetch.get(getTagListUrl, { params: data })
}

/**
 * @name: getClassify 获取相关明星
 * @param {type}
 * @return: Promise
 */
export function getTagsByName(data = {}): Promise<AxiosResponse> {
  return fetch.get(getTagsByNameUrl, { params: data })
}
